import React, { Component } from 'react';
// Bar graph
import FreightByLoBBar from "./FreightByLoBBar";
// Table state -> Kind -> Customers
import ShipToStateTable from "./ShipToStateTable";
// Table salesPerson -> Kind -> Customers
import SalesPersonStateTable from "./SalesPersonStateTable";
// Map
import USAMap from "./USAMap";

// Menu
import { Menu } from "../../components/Menu/Menu";

const demoRows = [
  { ShipToState: "TX", ProductLineDesc: "Distributor", BillToName: "Tienda La Bendición LLC", Envios: 1, FreightAmt: 403, diffPct: -27 },
  { ShipToState: "TX", ProductLineDesc: "Warehouse",   BillToName: "Cliente Houston",         Envios: 2, FreightAmt: 820, diffPct: -18 },
  { ShipToState: "VA", ProductLineDesc: "Pallet",      BillToName: "Richmond Store",          Envios: 3, FreightAmt: 1200, diffPct: -12 },
];

const demoSalesPersonRows =[
  { SalesPerson: "AS", ProductLineDesc: "Distributor", BillToName: "Tienda La Bendición LLC", Facturado: 1, FleteCobrado: 403, FacturaCarrier: -27, SubsidioCantidad: 455, SubsidioProcentaje: 23  },
  { SalesPerson: "AM", ProductLineDesc: "Warehouse",   BillToName: "Cliente Houston",         Facturado: 2, FleteCobrado: 820, FacturaCarrier: -18, SubsidioCantidad: 455, SubsidioProcentaje: 23  },
  { SalesPerson: "RR", ProductLineDesc: "Pallet",      BillToName: "Richmond Store",          Facturado: 3, FleteCobrado: 1200, FacturaCarrier: -12, SubsidioCantidad: 455, SubsidioProcentaje: 23  },
];

export default class Logistics extends Component {
  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
  }

  state = {
    Refresh: false
  }

  render() {
    return (
      <div id="GeneralPages" className="page">
        {/* Main menu */}
        <Menu Refresh={this.state.Refresh} Father={this} />

        <div className="container-fluid mayaland-dash py-4">
          {/* HEADER / BRAND + KPI TILES */}
          <div className="row g-3 align-items-stretch mt-4">
            <div className="col-12 col-lg-3 d-flex">
              <div className="card glass-card flex-fill p-3">
                <div className="d-flex align-items-center gap-3">
                  <div className="brand-circle">M</div>
                  <div>
                    <h5 className="mb-0 fw-bold text-white">Mayaland</h5>
                    <small className="text-white">Logistics & Sales Dashboard</small>
                  </div>
                </div>
              </div>
            </div>

            {/* KPI tiles */}
            <div className="col-12 col-lg-9">
              <div className="row g-3">
                <div className="col-12 col-md-3">
                  <div className="card kpi-tile danger">
                    <div className="kpi-label">% FLETE PAGADO/VENTAS</div>
                    <div className="kpi-value">-11.05%</div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="card kpi-tile danger">
                    <div className="kpi-label">DIFERENCIA = F.C. - F.P.</div>
                    <div className="kpi-value">($62K)</div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="card kpi-tile warning">
                    <div className="kpi-label">% SUBSIDIO = DIF / F.P.</div>
                    <div className="kpi-value">-31.79%</div>
                    <div className="kpi-delta subtle">vs. mes anterior</div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="card kpi-tile info">
                    <div className="kpi-label">% SUBSIDIO / VENTAS</div>
                    <div className="kpi-value">-3.51%</div>
                    <div className="kpi-delta subtle">objetivo: -2.0%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FILTERS */}
          <div className="row g-3 mt-1">
            <div className="col-12">
              <div className="card glass-card p-3">
                <div className="row g-3">
                  <div className="col-6 col-md-3">
                    <label className="form-label mb-1">Year</label>
                    <select className="form-select form-select-sm">
                      <option>2025</option>
                      <option>2024</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="form-label mb-1">SalespersonNo</label>
                    <select className="form-select form-select-sm">
                      <option>All</option>
                      <option>AM</option>
                      <option>AS</option>
                      <option>RR</option>
                      <option>WW</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="form-label mb-1">Month, Day</label>
                    <select className="form-select form-select-sm">
                      <option>All</option>
                      <option>Jan</option>
                      <option>Feb</option>
                      <option>Mar</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-3">
                    <label className="form-label mb-1">Línea de Negocio</label>
                    <select className="form-select form-select-sm">
                      <option>All</option>
                      <option>Pallet</option>
                      <option>Distributor</option>
                      <option>Supermarket</option>
                      <option>Warehouse</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* MAIN VISUALS */}
          <div className="row g-3 mt-1">
            {/* Pie + Bar stacked column (left) */}
            <div className="col-12 col-xl-4 d-flex flex-column gap-3">
              <div className="card glass-card p-3 flex-fill">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0 fw-bold text-white">Flete por Línea de Negocio</h6>
                  <span className="badge bg-light text-body-tertiary text-primary">2025</span>
                </div>
                <div className="chart-placeholder rounded-3" data-chart="pie-lob">
                  <FreightByLoBBar
                    labels={["Pallet", "Distributor", "Supermarket", "Warehouse"]}
                    values={[183000, 131300, 62300, 58100]}
                  />
                </div>
              </div>

              <div className="card glass-card p-3 flex-fill">
                <h6 className="mb-2 fw-bold text-white">Flete COBRADO vs PAGADO</h6>
                <div className="chart-placeholder rounded-3" data-chart="bar-freight">
                  <FreightByLoBBar
                    labels={["Flete cobrado", "Flete pagado"]}
                    values={[134000, 124000]}
                  />
                </div>
              </div>
            </div>

            {/* Map (right large) */}
            <div className="col-12 col-xl-8">
              <div className="card glass-card p-3 h-100">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0 fw-bold text-white">Distribución de Fletes US</h6>
                </div>
                <div className="map-placeholder rounded-3" data-viz="usa-map">
                  <USAMap
                    points={[
                      // ejemplo: burbujas demo
                      { lat: 29.7604, lng: -95.3698, value: 12, label: "Houston, TX" },
                      { lat: 32.7767, lng: -96.7970, value: 8,  label: "Dallas, TX" },
                      { lat: 34.0522, lng: -118.2437, value: 15, label: "Los Ángeles, CA" },
                      { lat: 41.8781, lng: -87.6298, value: 10, label: "Chicago, IL" },
                      { lat: 25.7617, lng: -80.1918, value: 6,  label: "Miami, FL" }
                    ]}
                    onReady={function (map) {
                      // si quieres hacer fitBounds a tus puntos:
                      // var latlngs = [];
                      // var pts = this.props.points || [];
                      // for (var i = 0; i < pts.length; i++) latlngs.push([pts[i].lat, pts[i].lng]);
                      // if (latlngs.length > 0) map.fitBounds(latlngs, { padding: [20, 20] });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* TABLES */}
          <div className="row gy-3 gx-3 mt-3 gap-fix">
            {/* Left table: ShipToState */}
            <div className="col-12 col-lg-6 d-flex justify-content-center">
              <ShipToStateTable rows={demoRows} onExport={() => console.log("Export CSV")} />
            </div>

            {/* Right table: SalespersonNo */}
            <div className="col-12 col-lg-6 d-flex justify-content-center">
              <SalesPersonStateTable rows={demoSalesPersonRows} onExport={() => console.log("Export CSV")} />
              {/* <div className="card glass-card table-card w-100 bg-white">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 fw-bold text-dark">SalespersonNo</h6>
                </div>
                <div className="table-responsive">
                  <table className="table table-sm table-hover align-middle mb-0">
                    <thead>
                      <tr>
                        <th>Salesperson</th>
                        <th className="text-end">Facturado MYLND</th>
                        <th className="text-end">Flete Cobrado</th>
                        <th className="text-end">Factura Carrier $</th>
                        <th className="text-end">Subsidio $</th>
                        <th className="text-end">Subsidio %</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fw-semibold">AS</td>
                        <td className="text-end">$635,352.72</td>
                        <td className="text-end">$48,787</td>
                        <td className="text-end">$82,681</td>
                        <td className="text-end text-danger">($33,895)</td>
                        <td className="text-end text-danger">-41%</td>
                      </tr>
                      <tr>
                        <td className="fw-semibold">AM</td>
                        <td className="text-end">$544,101.67</td>
                        <td className="text-end">$48,874</td>
                        <td className="text-end">$74,224</td>
                        <td className="text-end text-danger">($25,350)</td>
                        <td className="text-end text-danger">-34%</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr className="table-total">
                        <td>Total</td>
                        <td className="text-end">$1,758,887.20</td>
                        <td className="text-end">$132,574</td>
                        <td className="text-end">$194,352</td>
                        <td className="text-end text-danger">($61,777)</td>
                        <td className="text-end text-danger">-27.8%</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div> */}
            </div>
          </div>

        </div>
      </div>
    );
  }
}


